import { render } from "./AuthFooter.vue?vue&type=template&id=239ddf15&scoped=true"
import script from "./AuthFooter.vue?vue&type=script&lang=js"
export * from "./AuthFooter.vue?vue&type=script&lang=js"

import "./AuthFooter.vue?vue&type=style&index=0&id=239ddf15&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-239ddf15"

export default script